import {UserInfo} from '../../../user/components/user-information/users-info';

export class UserApplication extends UserInfo {
  public stateId: number;
  public coverLetter: string;
  public applicationDate: string;
  public processingDate: string;
  public processedByName: string;
  public documentInfoList: any[];
  public confirmationDocumentInfoList: any[];
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/user-application-dialog/user-application.ts